<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn padbtn">
          <div class="col-4" v-if="canCreate()">
            <button type="button" class="btn btn-secondary btn-fg custom-shadow-btn" @click="$router.push('/companies/create')">
              <i class="fa fa-plus"></i>
              Agregar Empresa
            </button>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-12 text-center">
            <h6 class="text-muted">Empresas Activos</h6>
          </div>
        </div>
        <div v-if="canIndex()" class="text item">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <el-select
              class="select-default mb-3"
              style="width: 200px"
              v-model="pagination.perPage"
              placeholder="Por pagina">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            <el-input
                      class="mb-3"
                      style="width: 200px"
                      placeholder="Buscar registros"
                      v-model="searchQuery"
                      aria-controls="datatables"/>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border>
              <el-table-column type="index" width="65"></el-table-column>
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                :min-width="150"
                fixed="right"
                label="Acciones">
                <template slot-scope="props">
                  <a v-if="canShow()" v-tooltip.top-center="'Ver'" class="btn-info btn-simple btn-link"
                     @click="handleView(props.$index, props.row)">
                    <i class="fa fa-eye"></i></a>
                  <a v-if="canDepartment()" v-tooltip.top-center="'Gestionar Departamentos'" class="btn-primary btn-simple btn-link"
                     @click="handleDepartments(props.$index, props.row)">
                    <i class="fa fa-building"></i></a>
                  <a v-if="canUpdate()" v-tooltip.top-center="'Editar'" class="btn-warning btn-simple btn-link"
                     @click="handleEdit(props.$index, props.row)"><i
                    class="fa fa-edit"></i></a>
                  <a v-if="canDelete()" v-tooltip.top-center="'Borrar'" class="btn-danger btn-simple btn-link"
                     @click="handleDelete(props.$index, props.row)"><i class="fa fa-times"></i></a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="text-right" v-if="canPDF()">
        <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportToPDF('companies/pdf', 'empresas.pdf')">
          <i class="fa fa-file-pdf-o"></i>
          Exportar a PDF
        </button>
      </div>
    </div>
    <div class="col-6">
      <div class="text-left" v-if="canExcel()">
        <button class="btn btn-success btn-fg custom-shadow-btn" @click="exportToExcel('companies/excel', 'empresas.xlsx')">
          <i class="fa fa-file-excel-o"></i>
          Exportar a Excel
        </button>
      </div>
    </div>
    <el-dialog v-if="canShow()"
      :title="title"
      :visible.sync="modals.read">
        <p>A continuación encontrarás toda la información asociada al registro seleccionado.</p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <table class="table">
              <tbody v-if="rowData">
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6><b>NIT:</b></h6>
                    {{rowData.nit}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6><b>Nombre:</b></h6>
                    {{rowData.company}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6><b>Dirección:</b></h6>
                    {{rowData.address}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6><b>Correo:</b></h6>
                    {{rowData.email}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6><b>Telefono:</b></h6>
                    {{rowData.phone}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6><b>Sitio:</b></h6> Web
                    {{rowData.web_site}}
                  </td>
                </tr>
                <tr class="shadow-sm">
                  <td scope="row">
                    <h6 class="custom-margin-h6-table" ><b>Departamentos:</b></h6>
                    <template v-for="(department, index) in rowData.departments">
                      <el-tag :key="department.id"
                        size="small"
                        type="success"
                        :closable="false"
                        :close-transition="false">
                          {{department.department}}
                      </el-tag>
                      <br :key="index+'Index'" v-if="(((index+1) % 4) == 0)"/>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer footer-date-at" v-if="rowData">
            <p class="text-muted"><small>Creado el: {{rowData.created_at}}</small></p>
          </div>
      </div>
    </el-dialog>
    <el-dialog v-if="canDepartment()"
      :title="title"
      :visible.sync="modals.departments">
      <span>A continuación seleccione los departamentos a asociar con la empresa:</span><br><br>
      <el-select  multiple class="select-primary select_modules"
      v-model="companieForm.departments"
      filterable placeholder="Seleccione uno o varios departamentos">
        <el-option v-for="option in departments"
                    class="select-primary"
                    :value="option.id"
                    :label="option.department"
                    :key="option.department">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-danger" @click="closeModal('departments')">Cancelar</button>&nbsp;
        <button class="btn btn-success" @click="addOrDeleteDepartment()">Confirmar</button>
      </span>
    </el-dialog>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import showSwalAlert from 'src/util/alerts'
  import table from './companieTable'
  import moment from 'moment';

  export default {
    data () {
      return {
        companieForm: {
          nit: null,
          company: null,
          address: null,
          email: null,
          phone: null,
          web_site: null,
          departments: null,
          departments_ids: null,
        },
        departments: null,
        modals: {
          departments: false
        },
        tableColumns: table,
      }
    },
    mixins: [mixinMasters, mixinPermissions],
    methods: {
      handleView (index, row) {
        this.rowData = Object.assign({}, row)
        this.title = 'Empresa '+this.rowData.company
        this.rowData.created_at = moment(String(this.rowData.created_at)).format('MM/DD/YYYY hh:mm:ss')
        this.openModal('read')
      },
      handleDepartments (index, row) {
        this.companieForm = Object.assign({}, row)
        this.companieForm.departments = row.departments_ids
        this.title = 'Gestionar departamentos de '+row.company
        this.openModal('departments')
      },
      handleEdit (index, row) {
        this.companieForm = Object.assign({}, row)
        this.companieForm.departments = row.departments_ids
        localStorage.setItem( 'companieEdit', JSON.stringify(this.companieForm) )
        this.$router.push({ name: 'Editar Empresa' });
      },
      handleDelete (index, row) {
        this.companieForm = Object.assign({}, row)
        this.companieForm.departments = row.departments_ids
        showSwalAlert('Empresa', 'delete', true, null, 'empresa: '+row.company).then((result) => {
          if (result.value) this.deleteCompanie()
        })
      },
      deleteCompanie(){
        this.$emit('cotentLoading', true)          
        this.companieForm.route = 'companies'
        this.destroyMaster(this.companieForm)
          .then((response) => this.modifyTable(2, this.companieForm.id, response))
          .catch((error) => this.showMessageErrors(error))
      },
      addOrDeleteDepartment(){
        this.$emit('cotentLoading', true)          
        this.companieForm.route = 'companies/department'
        this.saveMaster(this.companieForm)
          .then((response) => this.modifyTable(3, this.companieForm.id, response, 'departments'))
          .catch((error) => this.showMessageErrors(error))
      },
    },
    created(){
      if(this.canIndex()){
        this.getMasters('companies').then((response) => {
          this.tableData = response.data.data
          this.searchFuse(['nit', 'company', 'address', 'email'])
          this.$emit('cotentLoading')          
        }).catch((error) => this.showMessageErrors(error))
        this.getMasters('departments/index')
          .then((response) => this.departments = response.data.data)
          .catch((error) => this.showMessageErrors(error))
      }
    }
  }
</script>

